/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  'jquery',
  'mustache',
  'pip-model',
  'plugin.tooltip',
  'pip-common.utils',
  'pip-events',
  'thd-overlay',
  'window'
],
  function dualPathAddOn(
    $,
    Mustache,
    pip,
    tooltip,
    utils,
    pipEvents,
    THDOverlay,
    window
  ) {
    var model = {
      setOptInState: function setOptInState(isOptedIn) {
        pip.customer.dualPath.isOptedIn = !!isOptedIn;
        pipEvents.dualPath.dualPathOptInStateChanged.trigger();
      },
      getTechshedFormURL: function getTechshedFormURL() {
        var programCategory;
        var techShedURL;
        if (pip.features.useWWWLeadGenHost) {
          programCategory = pip.serviceAddOns.sellFurnishInstall.installationProgramCategory;
          techShedURL = 'https://' + pip.remoteHosts.newTechShedHost + '/services/i/' + programCategory + '/form?vfrom=iframe-dual&internet_id=' + pip.products.primary.data.itemId + '&pageType=PIP#';
        } else if (pip.features.useNewLeadGenEndpoint) {
          programCategory = pip.serviceAddOns.sellFurnishInstall.installationProgramCategory;
          techShedURL = 'https://' + pip.remoteHosts.techShedHost + '/services/i/' + programCategory + '/form?vfrom=iframe-dual&internet_id=' + pip.products.primary.data.itemId + '&pageType=PIP#';
        } else {
          programCategory = pip.serviceAddOns.sellFurnishInstall.installationProgramCategory || 'brio_inaisle_sfi_generalfs';
          techShedURL = 'https://' + pip.remoteHosts.techShedHost + '/services/brio/' + programCategory + '/?internet_id=' + pip.products.primary.data.itemId + '&pageType=PIP#';
        }
        return techShedURL;
      },
      getCarpetInstallation: function getCarpetInstallation() {
        var itemExtension = utils.deepGet(pip, 'products.primary.data.itemExtension') || {};
        var categoryId = itemExtension.categoryId || null;
        var categoryName = itemExtension.categoryName || null;

        return (pip.features
          && pip.features.dualPathForCarpetInstallationEnabled
          && categoryId === '530944'
          && categoryName === 'Carpet Samples');
      },
      getCarpetInstallationData: function getScheduleMeasureData() {
        return {
          isCarpetInstallation: model.isCarpetInstallation,
          modelNumber: utils.deepGet(pip.products.primary, 'data.info.modelNumber')
        }
      }
    };

    var view = {
      selectors: {
        checkbox: '#dual-path__checkbox',
        whatToExpect: '.buybox__dual-path .buybox__add-on__learn-more-cta',
        requestAQuoteBtn: '#request-a-quote-btn',
        scheduleMeasureBtn: '#schedule-a-measure-btn',
        addOnContainer: '#add-on__container'
      },
      templates: {
        addOn: $('#dual-path-add-on-template').html(),
        tooltip: $('#dual-path-tooltip-template').html()
      },
      render: {
        getAddOnTemplate: function getAddOnTemplate() {
          return Mustache.render(view.templates.addOn, model.getCarpetInstallationData());
        },
        getTooltipTemplate: function getTooltipTemplate() {
          return Mustache.render(view.templates.tooltip, model.getCarpetInstallationData());
        }
      },
      initEventListeners: function initEventListeners() {

        $(view.selectors.whatToExpect).tooltip({
          type: 'click',
          position: 'bottom',
          content: view.render.getTooltipTemplate(),
          width: utils.getTooltipSize(),
          closeButton: true,
          bestPosition: false,
          closeOnClick: true
        });

        $(window.document).off('.dual-path');
        $(window.document).on('click.dual-path', view.selectors.checkbox, function () {
          var isChecked = $(this).is(':checked');

          if (model.isCarpetInstallation) {
            $(view.selectors.scheduleMeasureBtn).toggle(isChecked);
          } else {
            model.setOptInState(isChecked);
          }
        });

        pipEvents.dualPath.dualPathOptInStateChanged.off('.dualPathStateChanged');
        pipEvents.dualPath.dualPathOptInStateChanged.on('.dualPathStateChanged', function (e) {
          $(view.selectors.checkbox).prop('checked', pip.customer.dualPath.isOptedIn);
          $(view.selectors.requestAQuoteBtn).toggle(pip.customer.dualPath.isOptedIn);
        });

        pipEvents.dualPath.dualPathBuyBeltLinkClicked.off('.dualPathBuyBeltLinkClicked')
        pipEvents.dualPath.dualPathBuyBeltLinkClicked.on('.dualPathBuyBeltLinkClicked', function () {
          model.setOptInState(false);
        });

        $(window.document).on('click.dual-path', view.selectors.requestAQuoteBtn, function (e) {
          e.preventDefault();
          pipEvents.requestQuote.dualPathRequestQuoteButtonClicked.trigger();

          var overlayOptions = {
            channel: pip.platform === 'MOBILE' ? 'mobile' : 'desktop',
            iframeSrc: model.techshedFormURL,
            header: false,
            closeButton: true
          };

          var overlay = new THDOverlay(overlayOptions);
          overlay.open();
        });
      }
    };

    return {
      init: function init() {
        pip.customer.dualPath = {
          isOptedIn: false
        };
        model.isCarpetInstallation = model.getCarpetInstallation();

        $(view.selectors.addOnContainer).html(view.render.getAddOnTemplate());

        if (!model.isCarpetInstallation) {
          model.techshedFormURL = model.getTechshedFormURL();
        }

        view.initEventListeners();
      },
      model: model,
      view: view,
      isDualPathDisplayable: function isDualPathDisplayable() {
        if (model.getCarpetInstallation()) {
          return true;
        } else if (pip.features.useWWWLeadGenHost) {
          return !!(pip.serviceAddOns
            && pip.serviceAddOns.sellFurnishInstall
            && pip.serviceAddOns.sellFurnishInstall.isDualPathSku
            && pip.serviceAddOns.sellFurnishInstall.installationProgramCategory
            && pip.remoteHosts
            && pip.remoteHosts.newTechShedHost);
        } else if (pip.features.useNewLeadGenEndpoint) {
          return !!(pip.serviceAddOns
            && pip.serviceAddOns.sellFurnishInstall
            && pip.serviceAddOns.sellFurnishInstall.isDualPathSku
            && pip.serviceAddOns.sellFurnishInstall.installationProgramCategory
            && pip.remoteHosts
            && pip.remoteHosts.techShedHost);
        } else {
          return !!(pip.serviceAddOns
            && pip.serviceAddOns.sellFurnishInstall
            && pip.serviceAddOns.sellFurnishInstall.isDualPathSku
            && pip.remoteHosts
            && pip.remoteHosts.techShedHost);
        }
      }
    }
  });

}.call(window));